import { Command } from 'ckeditor5';

export class QualioCodeBlockCommand extends Command {
  static readonly commandName = 'QualioCodeBlockCommand';

  execute(): void {
    this.editor.execute('codeBlock');
  }

  refresh(): void {
    this.isEnabled = true;
  }
}
